module.exports = __webpack_public_path__ + "img/frame.b2bd783e.png";